import { defineNuxtPlugin, useRuntimeConfig, useRouter } from "nuxt/app";
import * as Sentry from "@sentry/nuxt";

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig();
  if (!config.public.SENTRY_DSN) return;

  const router = useRouter();
  router.afterEach((to) => {
    Sentry.setContext("route", { path: to.path, name: to.name });
  });
});
